module.exports = __webpack_public_path__ + "img/Image23.8ba81ac9.jpg";